import React from 'react';
import {Box, Typography} from '@mui/material';

export const NoRowsOverlay: (entityName: string) => React.FC = (entityName) => {
  return () => (
    <Box p={5} flex={1} display="flex" justifyContent="center" alignContent="center">
      <Typography>No {entityName} found</Typography>
    </Box>
  );
};
